import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Downshift from 'downshift';
import Isvg from 'react-inlinesvg';
import { intlShape } from 'react-intl';
import { deepExtract } from 'helpers/deep';
import css from './SearchBox.scss';

export class SearchBoxField extends Component {
  inputRef = React.createRef();

  blurInput = () => {
    const input = deepExtract('current', this.inputRef);
    if (input) {
      input.blur();
    }
  };

  handleSelect = item => {
    const { onSelect, onValueChange, onClose } = this.props;

    this.downshift.closeMenu();
    this.blurInput();
    onValueChange('');
    onClose();
    onSelect(item);
  };

  handleClear = () => {
    const { onClear } = this.props;

    this.downshift.clearSelection();

    onClear();
  };

  handleChange = event => {
    const { onValueChange } = this.props;

    onValueChange(event.target.value);
  };

  handleFocus = () => {
    const { onFieldFocus, onValueChange } = this.props;

    onValueChange('');
    onFieldFocus();
  };

  handleBlur = () => {
    const { onValueChange, onClose, isOpenPanelOnMobile } = this.props;
    if (!isOpenPanelOnMobile) {
      onValueChange('');
      onClose();
    }
  };

  render() {
    const {
      isOpen,
      inputValue,
      blurredValue,
      isOpenPanelOnMobile,
      itemToString,
      placeholder,
      children,
      icon,
      isClearable,
    } = this.props;

    return (
      <div
        className={cx(css.searchbox__input, {
          [css['searchbox__input--selected']]: isOpen,
        })}>
        <div className={css.searchbox__input__icon}>{icon}</div>

        <Downshift
          isOpen={isOpen}
          inputValue={isOpen ? inputValue : blurredValue}
          onSelect={this.handleSelect}
          itemToString={itemToString}>
          {downshift => {
            this.downshift = downshift;

            const { getInputProps, isOpen: isOpenLocal } = downshift;

            return (
              <div>
                <input
                  {...getInputProps({
                    autoComplete: 'off',
                    onChange: this.handleChange,
                    onFocus: this.handleFocus,
                    onBlur: this.handleBlur,
                    placeholder,
                  })}
                  autoFocus={isOpen} // eslint-disable-line jsx-a11y/no-autofocus
                  ref={this.inputRef}
                />

                {isOpenLocal &&
                  children({
                    onPanelScroll: isOpenPanelOnMobile ? this.blurInput : undefined,
                    ...downshift,
                  })}
              </div>
            );
          }}
        </Downshift>

        {isClearable && blurredValue && !isOpenPanelOnMobile && (
          <div
            className={cx(css.searchbox__input__icon, css['searchbox__input__icon--light'])}
            onClick={this.handleClear}>
            <Isvg src={require('static/design-system/icons/cross-small-circle.svg')} />
          </div>
        )}
      </div>
    );
  }
}

SearchBoxField.propTypes = {
  children: PropTypes.func.isRequired,
  blurredValue: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  isOpen: PropTypes.bool,
  isOpenPanelOnMobile: PropTypes.bool,
  isClearable: PropTypes.bool,
  itemToString: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClear: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired,
};
